export const createOrUpdateIdpConfig = async ({ idpConfig, successCallback, errorCallback }) => {
  const response = await fetch('/account_idp_configs', {
    method: 'POST',
    body: JSON.stringify(idpConfig),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const contentType = response.headers.get('content-type');

  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError("Oops, we haven't got JSON!");
  }

  const responseJson = await response.json();

  if (!response.ok) {
    const errorMessage = `Error ${response.status}: ${responseJson.error}`;
    return errorCallback(errorMessage);
  }

  successCallback(responseJson);
};
